var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-typinguserslist"},[_vm._l((_vm.typingUsers),function(user,idx){return _c('span',{key:user.nick,style:({ color: _vm.userColour(user) })},[_vm._v("\n        "+_vm._s(user.nick)+_vm._s(_vm.typingUsers.length - 1 > idx ? ',' : '')+"\n    ")])}),_vm._v(" "+_vm._s(_vm.typingUsers.length > 0 ? '…' : '')+"\n")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13906cf7","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TypingUsersList.vue
// module id = H64e
// module chunks = 1